import React from "react";
import "./ProductCardContainer.scss";
import ProductCard from "./ProductCard";
import FullProductCard from "./FullProductCard";

const ProductCardContainer = (props) => {
  return (
    <div
      className={
        props.className === undefined
          ? "ProductCardContainer__"
          : props.className + " " + "ProductCardContainer__"
      }
    >
      {props?.data?.map((v, index) => {
        return props.type === "half" ? (
          <ProductCard
            url="/Group/product"
            key={"lo" + index}
            title={v?.title}
            src={v?.images[0]?.url}
            id={v?.id}
            mainPrice={v?.mainPrice}
            offer={v?.offer}
            offerPrice={v?.offerPrice}
            offPercent={v?.offPercent}
            score={v?.score}
            cardModel={v?.cardModel}
            status={v?.status}
            productInfo={v}
            inventory={v?.inventory}
            defaultValue={v?.defultValue}
          />
        ) : (
          <FullProductCard
            url="/Group/product"
            key={"lo" + index}
            title={v?.title}
            src={v?.images[0]?.url}
            mainPrice={v?.mainPrice}
            offer={v?.offer}
            id={v?.id}
            offerPrice={v?.offerPrice}
            offPercent={v?.offPercent}
            score={v?.score}
            cardModel={v?.cardModel}
            status={v?.status}
            productInfo={v}
            inventory={v?.inventory}
            defaultValue={v?.defultValue}
          />
        );
      })}
    </div>
  );
};

export default ProductCardContainer;
